<template>
  <div id="app" 
    :class="['d-flex flex-column',
            isBlogPage ? 'custom-bg' : '']">
    <!--<div id="custom-backdrop" 
      v-show="showBackdrop"
      @click="hideBackdrop">
    </div>-->
    <div class="nav-wrapper position-relative">
      <div class="w-100" v-sticky:top="{minWidth: 768, offset: 'vh'}">
        <b-navbar id="nav"
          v-b-scrollspy
          class="main-nav"
          toggleable="md" type="light" >
          <b-container>
            <div class="w-100 d-flex px-3 px-md-0 position-relative">
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand class="d-flex ml-auto d-md-none mr-0 mr-0">
                <a href="#home" @click="showMoreAndScroll">
                  <img src="/brand/color-short.svg" alt="Noemi Leon: Professional Portfolio" width="40">
                </a>
              </b-navbar-brand>
              <b-navbar-brand class="d-none d-md-flex">
                <a href="#home" @click="showMoreAndScroll">
                  <img src="/brand/color-horizontal.svg" alt="Noemi Leon: Professional Portfolio" width="140">
                </a>
              </b-navbar-brand>
              <b-collapse id="nav-collapse" class="nav-header" is-nav>
                <div class="h-100 w-100">
                  <div class="d-md-none h-100">
                    <b-navbar-nav class="h-100 d-flex flex-column justify-content-around align-items-center">
                      <b-nav-item>
                        <b-navbar-toggle target="nav-collapse" class="nav-collapse-mobile">
                          <i class="fas fa-times nav-item-icon"></i>
                        </b-navbar-toggle>
                      </b-nav-item>
                      <b-nav-item
                        id="home-nav-item"
                        href="#home"
                        @click="showMoreAndScroll">
                        <i class="fas fa-house-user nav-item-icon" aria-hidden="true"></i>
                      </b-nav-item>
                      <b-nav-item
                        href="#about"
                        @click="showMoreAndScroll">
                        <i class="far fa-user nav-item-icon" aria-hidden="true"></i>
                      </b-nav-item>
                      <b-nav-item 
                        class="" 
                        href="#skills"
                        @click="showMoreAndScroll">
                        <i class="fas fa-user-ninja nav-item-icon" aria-hidden="true"></i>
                      </b-nav-item>
                      <b-nav-item 
                        class="" 
                        href="#experience"
                        @click="showMoreAndScroll">
                        <i class="fas fa-building nav-item-icon "></i>
                      </b-nav-item>
                      <b-nav-item 
                        class="" 
                        href="#projects"
                        @click="showMoreAndScroll">
                        <i class="fas fa-icons nav-item-icon"></i>
                      </b-nav-item>
                      <b-nav-item 
                        class="" 
                        href="#contact"
                        @click="showMoreAndScroll">
                        <i class="fas fa-comments nav-item-icon"></i>
                      </b-nav-item>
                      <b-nav-item 
                        class="" 
                        href="#communities"
                        @click="showMoreAndScroll">
                        <i class="fas fa-users nav-item-icon"></i>
                      </b-nav-item>
                    </b-navbar-nav>
                  </div>
                  <div class="d-none d-md-flex h-100 align-items-center justify-content-end">
                    <b-navbar-nav>
                      <template v-if="isHomePage">
                        <b-nav-item 
                          href="#about"
                          @click="showMoreAndScroll">
                          About
                        </b-nav-item>
                        <b-nav-item 
                          href="#skills"
                          @click="showMoreAndScroll">
                          Skills
                        </b-nav-item>
                        <b-nav-item href="#experience"
                          @click="showMoreAndScroll">
                          Carreer
                        </b-nav-item>
                        <b-nav-item href="#projects"
                          @click="showMoreAndScroll">
                          Projects
                        </b-nav-item>
                        <b-nav-item href="#contact"
                          @click="showMoreAndScroll">
                          Contact
                        </b-nav-item>
                        <b-nav-item 
                          href="#communities"
                          @click="showMoreAndScroll">
                          Communities
                        </b-nav-item>
                      </template>
                      <template v-else>
                        <b-nav-item 
                          :to="{ name: 'Home' }"
                        >
                          Home
                        </b-nav-item>
                        <b-nav-item 
                          :to="{ name: 'demo' }"
                        >
                          Demo
                        </b-nav-item>
                      </template>
                    </b-navbar-nav>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-container>
        </b-navbar>
      </div>
    </div>

    <!--<transition name="fade" mode="out-in">-->
      <router-view class="flex-grow-1"/>
    <!--</transition>-->
    
  </div>
</template>

<script>
export default {
  data() {
    return {
       showBackdrop: false,
    }
  },
  methods: {
    hideBackdrop(){
      document.getElementById('nav-collapse-btn').click();
    },
    showMoreAndScroll(evt){
      this.$root.$emit('showMoreSections');
       setTimeout(() => {
        this.scrollIntoView(evt);
      }, 300);
    },
    scrollIntoView(evt) {
      evt.preventDefault()
      const href = evt.target.getAttribute('href');
      if(href != "/"){ //another view, no scroll to move
        const el = href ? document.querySelector(href) : null
        if (el) {
          window.scrollTo({ top: el.offsetTop, behavior: 'smooth' });
        }
      }
    },
  },
  watch: {
    showBackdrop(val){
      if(val === true)
        document.body.className = 'noScroll-y';
      else
        document.body.className = '';
    }
  },
  computed: {
    isHomePage(){
      const routeName = this.$route.name;
      if( routeName === 'Home')
        return true;
      return false;
    },
    isBlogPage(){
      const routeName = this.$route.name;
      if( routeName != null 
      && routeName.indexOf('blog') >= 0)
        return true;
      return false;
    }
  }
}
</script>
<style>
:root{
  --gray-dark: #2C2B30;
  --gray-med: #4F4F51;
  --gray-light: #D6D6D6;
  --pink-light: #ffd9d1;/*#fac8bd; #f5d5db;*/ /*#F2C4CE;*/
  --pink-accent: #F58F7C;
  --gray-form: rgba(0,0,0,.5);

  --gray-bg: #ebeff2;
  --photo-bg: #f9f9f9;
}
#app{
  color: var(--gray-dark);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
}
body{
  overflow-x: hidden;
}
.main-nav .container{
  box-shadow: none;
}
.main-nav .nav-link{
  color: var(--gray-dark) !important;
}
.main-nav .nav-link:hover{
  color: var(--pink-accent);
}
.main-nav .router-link-exact-active {
  border-bottom: 2px solid var(--pink-light);
}
.nav-item.active{
  border-bottom: 2px solid var(--pink-light);
}
.nav-wrapper .el-fixed{
  box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);
  background: #fff;
  z-index: 9;
}
/* transition */
.fade-enter{
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.1s ease-in;
}
.fade-leave-to{
  opacity: 0;
}
.fade-leave-active{
  transition: opacity 0.1s linear ;
}

@font-face {
  font-family: "Bad Script";
  src: url('assets/fonts/BadScript-Regular.ttf');
  font-weight: 200;
  font-style: normal;
  unicode-range: U+000-5FF; 
  font-display: swap;
}
@font-face {
  font-family: "VT323";
  src: url('assets/fonts/VT323-Regular.ttf');
  font-weight: 200;
  font-style: normal;
  unicode-range: U+000-5FF; 
  font-display: swap;
}
.font-bad{
  font-family: "Bad Script", Arial , cursive;
}
.font-code{
  font-family: "VT323", Arial;
}
.cover-height{
  height: 100vh;
}
.cover-height-wnav{
  height: calc(100vh - 70px -92px);
}

.bg-photo{
  background-color: var(--photo-bg);
}
.bg-gray-light{
  background-color: var(--gray-bg);
}
.bg-gray-dark{
  background-color: var(--gray-dark);
  color: #fff;
}
.bg-pink-light{
  background-color: var(--pink-light);
}
.color-pink-light{
  color: var(--pink-light);
}
.color-gray-light{
  color: var(--gray-light);
}
.color-pink-accent{
  color: var(--pink-accent);
}
.color-gray-med{
  color: var(--gray-med);
}
.color-gray-dark{
  color: var(--gray-dark);
}
.link-accent{
  color: var(--gray-med);
}
.link-accent:hover{
  color: var(--pink-accent) !important;
}
.color-dark{
  color: #000;
}
.link-circle{
  border-color: var(--gray-med);
}
.link-circle:hover{
  border-color: var(--pink-accent) !important;
  text-decoration: none;
}
.bg-pink{
  background-color: var(--pink-light);
}
.nav-item-icon {
  color: #F58F7C !important;
}
.link-circle{
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-width: 1px;
  border-style: solid;
}
.section{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.social-net{
  max-width: 160px;
}

.hidden-section{
  min-height: 1px;
}

.move-enter-active {
  animation: move-in 2.5s;
}
@keyframes move-in {
  0% {
    transform: translateX(200%);
  }
  100% {
    transform: translateX(0);
  }
}
.title-wrapper{
  margin-bottom: 3.5rem;
}
.title-wrapper:hover >span:after{
  transition: width 0.5s;
  width: 80px; /*width: 0;*/
}
.title-wrapper >span:after{
  display: block;
  content: " ";
  width: 80px;
  height: 4px;
  background: var(--pink-light);
  margin-left: auto;
  margin-right: auto;
  margin-top: 4px;
}
.title-wrapper.dark >span:after{
  background: var(--pink-accent);
}
/* ./transition */
#nav-collapse {
  width: 80px;
  z-index: 20;
  position: fixed;
  display: block;
  height: 100vh;
  overflow-y: auto;
  left: -240px;
  top: 0px;
  transition: transform 350ms linear !important;
  background-color: rgba(0, 0, 0, 0.8);
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}
#nav-collapse.collapsing{
  position: fixed !important;
  height: 100vh !important;
}
#nav-collapse.collapse.show {
  display: block !important;
  transform: translateX(240px);
  height: 100vh;
  height: -webkit-fill-available;
}
.nav-item-icon{
  font-size: 40px;
  pointer-events: none;
}
.nav-collapse-mobile{
  border: none;
  padding: 0;
}
.navbar{
  padding-left: 0;
  padding-right: 0;
}
@media (min-width: 576px) { 
  .cover-height
 {
    height: auto;
  }
}
@media (min-width: 768px){
  #nav-collapse {
    position: relative;
    top: 0;
    left: 0;
    overflow-y: visible;
    height: inherit;
    padding: 0;
    background-color: transparent;
  }
  .cover-height-wnav{
    height: calc(100vh - 64px - 88px);
  }
}
</style>
